export default __webpack_public_path__ + "static/media/indie-flower-regular.9bd64a34.ttf";